import EventEmitter from 'eventemitter3';

import { CONFIG } from '../consts';

export const RouterEvent = {
    ROUTE_CHANGE: '__re_router_change'
};

/**
 * Manage routes
 */
class Router extends EventEmitter {
    constructor() {
        super();

        this._locked = false;
        this.urls = {
            origin: window.location.origin || window.location.protocol + '//' + window.location.hostname,
            current: window.location.href
        };
        this.title = document.title || '';

        bindAll(this, [
            'listen',
            '_linkClickedHandler'
        ]);

        if (CONFIG.IS_AJAX)
            this._bind();
    }

    _bind() {
        window.addEventListener('popstate', this.listen);
        delegate(document.body, '[href]', 'click', this._linkClickedHandler, false);
    }

    listen() {
        if (!this._locked && this.urls.current != window.location.href) {
            this.redirect(window.location.href);
        }
    }

    _linkClickedHandler(event) {
        const linkUrl = event.delegateTarget.getAttribute('href');

        if (linkUrl.includes(this.urls.origin) && !event.delegateTarget.classList.contains('no-ajax')) {
            event.preventDefault();

            if (!this._locked) {
                this.redirect(linkUrl);
            }
        }
    }

    AJAXresponseHandler() {
        if (this.urls.current != window.location.href) {
            history.pushState({}, this.title, this.urls.current);
            if (window.ga)
			    ga('send', 'pageview');
        }
    }

    lock() {
        this._locked = true;
    }

    unlock() {
        this._locked = false;
    }

    redirect(url) {
        if (CONFIG.IS_AJAX) {
            this.urls.current = this._parseUrl(url);
            this.emit(RouterEvent.ROUTE_CHANGE);
        } else {
            document.location.href = url;
        }
    }

    setTitle(title) {
        document.title = this.title = title || document.title;
    }

    _parseUrl(url) {
        if (!url.includes(this.urls.origin))
            return this.urls.origin + url;
        return url;
    }

    getUrl() {
        return this.urls.current.replace(this.urls.origin, '');
    }
}

export default new Router();



// WEBPACK FOOTER //
// src/js/helpers/router.js